import { FocalPoint } from '@nucleus/types/media/image';

const DefaultFocalPoint: FocalPoint = {
  x: 0.5,
  y: 0.5,
};

export const convertFocalPointToPositionCss = (focalPoint?: Partial<FocalPoint>): string => {
  if (focalPoint === undefined) {
    return 'center';
  }

  const x = focalPoint.x ?? DefaultFocalPoint.x;
  const y = focalPoint.y ?? DefaultFocalPoint.y;

  // if x and y are both between 0 and 1, return the percentages
  // WARN: Values outside of 0 to 1 are valid, but our choice was to ignore them.
  if (x >= 0 && y >= 0 && x <= 1 && y <= 1) {
    return `${x * 100}% ${y * 100}%`;
  }

  return 'center';
};
